export const ICONS = {
    USER: "USER",
    POWER: "POWER",
    SEARCH: "SEARCH",
    WINDOWS: "WINDOWS",
    GITHUB: "GITHUB",
    LINKEDIN: "LINKEDIN",
    FOLDER: "FOLDER",
    ARROW: "ARROW",
    TEXT_FILE: "TEXT",
    SETTINGS: "SETTINGS",
    CROSS: "CROSS",
    VIEW_BOXES: "VIEW_BOXES",
    PLUS_CIRCLE: "PLUS_CIRCLE",
    RIGHT_ARROW: "RIGHT_ARROW",
    SQUARE_IN_SQUARE: "SQUARE_IN_SQUARE",
    SQUARE_OUTLINE: "SQUARE_OUTLINE",
    BROWSER: "BROWSER",
    LINE: "LINE",
    EDIT: "EDIT",
    FULL_ARROW: "FULL_ARROW",
    STASH: "STASH",
    SQUARE_LIST: "SQUARE_LIST",
    BIN: "BIN",
    SLEEP: "SLEEP",
    RELOAD: "RELOAD",
    TELEGRAM: "TELEGRAM",
    SKYPE: "SKYPE",
    STEAM: "STEAM",
    POSTMAN: "POSTMAN",
    WEBSTORM: "WEBSTORM",
    PDF: "PDF",
    DISK: "DISK",
    BRUSH: "BRUSH",
} as const;